// queries/useUpdateFeatured.ts
"use client";
import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { fetch } from "libs";
import { POST_UPDATE_FEATURED_STATUS } from "api";
import { UpdateFeaturedStatusParams } from "types";

export const useUpdateFeatured = (): UseMutationResult<void, Error, UpdateFeaturedStatusParams> => {
  return useMutation<void, Error, UpdateFeaturedStatusParams>({
    mutationFn: async ({ username, featured }): Promise<void> => {
      await fetch(POST_UPDATE_FEATURED_STATUS(username, featured), {
        method: "PUT",
      });
    },
    onSuccess: () => {
      console.log("Featured status updated successfully");
      // Optionally, you can trigger a refetch of models to reflect the change
    },
    onError: (error) => {
      console.error("Error updating featured status:", error);
    },
  });
};

export default useUpdateFeatured;
